module.exports = __webpack_public_path__ + "media/application/images/svgs/chevron-up-6ce778cf11c7d75a6bc7b5b59e731432.svg";